import { getAttributionReference } from "./attribution";

let metaInitialized = false;
let lastPageView = null;

function plausible(eventName, props) {
  if (typeof window === "undefined") return;
  window.plausible = window.plausible || function plausibleQueue() {
    (window.plausible.q = window.plausible.q || []).push(arguments);
  };
  window.plausible(eventName, { props });
}

function meta(eventType, eventName, properties) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(eventType, eventName, properties);
  }
}

export function initializeAnalytics(pixelId = process.env.REACT_APP_META_PIXEL_ID) {
  if (!pixelId || metaInitialized || typeof window === "undefined" || typeof document === "undefined") return false;
  /* Meta's loader is initialized only when a production ID is supplied at build time. */
  const fbq = window.fbq = window.fbq || function fbqQueue() {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  if (!fbq.loaded) {
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }
  window.fbq("init", pixelId);
  metaInitialized = true;
  return true;
}

function context(properties = {}) {
  return { attribution_reference: getAttributionReference(), ...properties };
}

export function trackPageView({ route, language, initial = false }) {
  const key = `${route}|${language}`;
  if (lastPageView === key) return;
  lastPageView = key;
  const properties = context({ route, language });
  // Plausible already records the initial document load; manual pageviews cover hash navigation only.
  if (!initial) plausible("pageview", properties);
  meta("track", "PageView", properties);
}

export function trackViewContent(properties = {}) {
  const payload = context(properties);
  plausible("ViewContent", payload);
  meta("track", "ViewContent", payload);
}

export function trackWhatsAppClick(properties = {}) {
  const payload = context(properties);
  plausible("WhatsAppClick", payload);
  meta("trackCustom", "WhatsAppClick", payload);
}

export function trackPhoneClick(properties = {}) {
  const payload = context(properties);
  plausible("PhoneClick", payload);
  meta("trackCustom", "PhoneClick", payload);
}

export function trackContact(properties = {}) {
  const payload = context(properties);
  plausible("Contact", payload);
  meta("track", "Contact", payload);
}

export function trackLead(properties = {}) {
  const payload = context(properties);
  plausible("Lead", payload);
  meta("track", "Lead", payload);
}

export function resetAnalyticsForTests() {
  metaInitialized = false;
  lastPageView = null;
}
